<template>
  <v-container fluid>
    <justificativas-overview :bdgdVersaoId="bdgdVersaoId" />
  </v-container>
</template>

<script>
  import JustificativasOverview from '@/components/geracao-bdgd/validacoes-bdgd/JustificativasOverview.vue';

  export default {
    name: 'JustificativasOverviewPage',
    components: { JustificativasOverview },
    computed: {
      bdgdVersaoId() {
        return parseInt(this.$route.params.bdgdVersaoId);
      }
    }
  };
</script>
